import request from '@/utils/request'

/**
 * 新增部门信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentAdd(data) {
  return request({
    type: 'base',
    url: 'department/add',
    method: 'post',
    data
  })
}
/**
 * 删除部门
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentDelete(data) {
  return request({
    type: 'base',
    url: 'department/delete',
    method: 'post',
    data
  })
}
/**
 * 获取部门详情
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentDetailGet(data) {
  return request({
    type: 'base',
    url: 'department/detail/get',
    method: 'post',
    data
  })
}
/**
 * 根据组织编号获取部门树形列表(不包含子组织的部门)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentListGet(data) {
  return request({
    type: 'base',
    url: 'department/list/get',
    method: 'post',
    data
  })
}
/**
 * 查询体系-组织-部门-成员的人员选择器树结构
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentOrgSysMemberSelectTreeList(data) {
  return request({
    type: 'base',
    url: 'department/org/sys/member/select/tree/list',
    method: 'post',
    data
  })
}
/**
 * 查询体系-组织-部门-成员的树结构(作废)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentOrgSysMemberTreeList(data) {
  return request({
    type: 'base',
    url: 'department/org/sys/member/tree/list',
    method: 'post',
    data
  })
}
/**
 * 查询体系-组织-部门的树形结构
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentOrgSysTreeList(data) {
  return request({
    type: 'base',
    url: 'department/org/sys/tree/list',
    method: 'post',
    data
  })
}
/**
 * 根据组织编号查询组织-部门树结构
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentOrgTreeGet(data) {
  return request({
    type: 'base',
    url: 'department/org/tree/get',
    method: 'post',
    data
  })
}
/**
 * 根据组织编号获取部门列表(包含子组织的部门)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentOrgchildListGet(data) {
  return request({
    type: 'base',
    url: 'department/orgchild/list/get',
    method: 'post',
    data
  })
}
/**
 * 根据体系ID查询部门列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentSysList(data) {
  return request({
    type: 'base',
    url: 'department/sys/list',
    method: 'post',
    data
  })
}
/**
 * 编辑部门
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function departmentUpdate(data) {
  return request({
    type: 'base',
    url: 'department/update',
    method: 'post',
    data
  })
}
/**
 * 根据部门id获取部门信息（oauth）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthDepartmentDetailGet(data) {
  return request({
    type: 'base',
    url: 'oauth/department/detail/get',
    method: 'post',
    data
  })
}
/**
 * 根据部门id获取部门信息（oauth,微服务提供接口所有）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthDepartmentDetailInterfaceGet(data) {
  return request({
    type: 'base',
    url: 'oauth/department/detail/interface/get',
    method: 'post',
    data
  })
}
/**
 * 根据组织获取部门列表（oauth）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthDepartmentDetailListGet(data) {
  return request({
    type: 'base',
    url: 'oauth/department/detail/list/get',
    method: 'post',
    data
  })
}
/**
 * 根据组织id、部门名称，获取部门信息（oauth）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthDepartmentInfoGet(data) {
  return request({
    type: 'base',
    url: 'oauth/department/info/get',
    method: 'post',
    data
  })
}
/**
 * 根据组织id、年份，获取部门信息（oauth）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthDepartmentInfoYearGet(data) {
  return request({
    type: 'base',
    url: 'oauth/department/info/year/get',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/Department.js